import theme from "@shared/utils/themeColors";
export function LoadingSpinner() {
  return (
    <div
      className={`animate-spin rounded-full h-8 w-8 border-b-2 ${theme.border.brand}`}
    ></div>
  );
}
